import { useTranslation } from "react-i18next";

interface PrivateReferenceRowProps {
  token: string;
}

/** Attached and live, but this viewer cannot read it: it stays, so it offers no Remove. */
export function PrivateReferenceRow(props: PrivateReferenceRowProps) {
  const { token } = props;
  const { t } = useTranslation("app");

  return (
    <div
      className="flex min-h-11 items-center text-sm text-muted-foreground"
      data-testid={`creative-private-reference-${token}`}
    >
      {t("creativeLibrary.referencePrivate")}
    </div>
  );
}
